<template>
  <div v-if="evse">
      {{ evse.startTime ? time : '-' }}
  </div>
</template>

<script>
import dayjs from "dayjs";
import Tools from "@includes/tools";

export default {

  data() {
    return {
      time: null,
    }
  },

  props: {
    evse: Object,
  },

  mounted() {
    this.interval = setInterval(() => {
      if(!this.paused) {
        let format = this.$t('charging-point.evse_format_duration')
        if(this.active) {
          let duration = dayjs().diff(dayjs(this.evse.startTime), 'seconds')
          if(duration) {
            if(duration >= 24 * 3600) {
              format = this.$t('charging-point.evse_format_duration_day_seconds')
            }
            this.time = Tools.formatDurationPattern(duration, format)
          }
        } else  {
          if(this.evse?.duration) {
            if(this.evse.duration >= 24 * 3600) {
              format = this.$t('charging-point.evse_format_duration_day_seconds')
            }
            this.time = Tools.formatDurationPattern(this.evse.duration, format)
          }
        }
      }
    }, 1000)
  },

  destroyed() {
    clearInterval(this.interval)
  },

  computed: {
    paused() {
      return this.evse.status === 'PAUSED'
    },
    active() {
      if(!this.evse) {
        return false
      }
      return this.evse.status === 'ACTIVE'
    }
  },

  methods: {
    convertToTime() {

    }
  }
}
</script>

<style>

</style>